<template>
    <footer class="footer">
        <div v-if="windowWidth < 991" class="container">
            <div class="row mb-2">
                <div class="col">
                    <div class="footer--title">
                        <div class="footer--annotation">
                            <a href="https://fundatia-vodafone.ro/">Fundaţia Vodafone</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div v-for="(item, index) in items" :key="index" class="col-lg-4">
                    <div :class="{ 'is-active': item.active }" class="accordion-item-trigger">
                        <div @click="toggle(item)" class="footer--title">
                            {{ item.name }}

                            <span class="accordion-box">
                                <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation"><path fill="currentColor" d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path><path fill="none" d="M0 0h24v24H0z"></path></svg>
                            </span>
                        </div>
                        <transition 
                            name="accordion-item"
                            @enter="startTransition"
                            @after-enter="endTransition"
                            @before-leave="startTransition"
                            @after-leave="endTransition">
                        >
                            <div v-show="item.active" class="accordion-item-details">
                                <ul>
                                    <li v-for="(item, index) in item.children" :key="index">
                                        <a class="footer--links" :href="item.url">
                                            {{ item.name }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4">
                    <div class="footer--title">
                        <a href="https://www.vodafone.ro/contact">
                            Contactează-ne
                        </a>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="footer--title">
                        <a href="https://www.vodafone.ro/magazine-vodafone/index.htm">
                            Găsește un magazin
                        </a>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="footer--title">
                        <div class="footer--annotation">
                            &copy; {{ copyYear }} Vodafone România
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="container">
            <div class="row">
                <div class="col">
                    <div class="footer--title">
                        <div class="footer--annotation">
                            <a href="https://fundatia-vodafone.ro/">Fundaţia Vodafone</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div v-for="(item, index) in items" :key="index" class="col-lg-4">
                    <div class="footer--title">
                        {{ item.name }}
                    </div>
                    <ul>
                        <li v-for="(item, index) in item.children" :key="index">
                            <a class="footer--links" :href="item.url">
                                {{ item.name }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4">
                    <div class="footer--title">
                        <a href="https://www.vodafone.ro/contact">
                            Contactează-ne
                        </a>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="footer--title">
                        <a href="https://www.vodafone.ro/magazine-vodafone/index.htm">
                            Găsește un magazin
                        </a>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="footer--title">
                        <div class="footer--annotation">
                            &copy; {{ copyYear }} Vodafone România
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: "Footer",
    data() {
        return {
            copyYear: null,
            windowWidth: null,
            items: [
                {
                    name: 'Despre Vodafone',
                    active: false,
                    children: [
                        {
                            name: 'Despre noi',
                            url: 'https://www.vodafone.ro/despre-noi/vodafone-romania/cine-suntem/index.htm'
                        },
                        {
                            name: 'Cariere',
                            url: 'https://www.vodafone.ro/despre-noi/vodafone-romania/cariere/index.htm'
                        },
                        {
                            name: 'Partener franciză',
                            url: 'https://www.vodafone.ro/despre-noi/vodafone-romania/cariere/partener-franciza/index.htm?icmp=hp-p-footer-franciza'
                        },
                        {
                            name: 'Media',
                            url: 'https://www.vodafone.ro/despre-noi/media/index.htm'
                        },
                        {
                            name: 'Evenimente',
                            url: 'https://www.vodafone.ro/despre-noi/evenimente/index.htm'
                        },
                        {
                            name: 'Implicare socială',
                            url: 'https://www.vodafone.ro/despre-noi/implicare-sociala/index.htm'
                        },
                        {
                            name: 'Politica de Livrare',
                            url: 'https://www.vodafone.ro/personal/asistenta/comenzi-online/magazinul-online/cum-intru-in-posesia-produselor-comandate-care-sunt-termenii-de-livrare/'
                        },
                        {
                            name: 'Politica de Retur',
                            url: 'https://www.vodafone.ro/personal/asistenta/comenzi-online/magazinul-online/ce-trebuie-sa-fac-pentru-a-returna-un-produs/'
                        },
                        {
                            name: 'Proiect fuziune Vodafone - UPC',
                            url: 'https://www.vodafone.ro/libs/documents/digital_asset/v630398.pdf'
                        }
                    ]
                },
                {
                    name: 'Aspecte Legale',
                    active: false,
                    children: [
                        {
                            name: 'Procedură restituire Roaming',
                            url: 'https://www.vodafone.ro/consumption/groups/public/documents/digital_asset/v453811.pdf'
                        },
                        {
                            name: 'Condiţiile de furnizare a serviciilor',
                            url: 'https://www.vodafone.ro/personal/servicii-si-tarife/termeni-si-proceduri-legale/conditiile-de-furnizare-a-serviciilor/index.htm'
                        },
                        {
                            name: 'Sumar actualizări Politică de confidențialitate',
                            url: 'https://www.vodafone.ro/consumption/groups/public/documents/digital_asset/v665507.pdf'
                        },
                        {
                            name: 'Politica de confidenţialitate',
                            url: 'https://www.vodafone.ro/consumption/groups/public/documents/digital_asset/v364945.pdf'
                        },
                        {
                            name: 'Cookies',
                            url: 'https://www.vodafone.ro/personal/servicii-si-tarife/termeni-si-proceduri-legale/politica-de-utilizare-a-cookie-urilor/index.htm'
                        },
                        {
                            name: 'Prevenirea Fraudei',
                            url: 'https://www.vodafone.ro/frauda'
                        },
                        {
                            name: 'ANPC',
                            url: 'http://www.anpc.gov.ro/'
                        },
                        {
                            name: 'Platforma SOL',
                            url: 'https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.chooseLanguage'
                        },
                        {
                            name: 'Interconectare',
                            url: 'https://www.vodafone.ro/personal/servicii-si-tarife/termeni-si-proceduri-legale/interconectare/index.htm#tab-1'
                        },
                        {
                            name: 'Parametrii de calitate',
                            url: 'https://www.vodafone.ro/personal/servicii-si-tarife/termeni-si-proceduri-legale/parametri-de-calitate/index.htm'
                        },
                        {
                            name: 'Termeni magazin online',
                            url: 'https://www.vodafone.ro/libs/documents/digital_asset/v146631.pdf'
                        },
                        {
                            name: 'Deșeuri provenite din EEE',
                            url: 'https://www.vodafone.ro/personal/servicii-si-tarife/termeni-si-proceduri-legale/informatii-privind-deseurile-provenite-din-echipamente-electrice-si-electronice/index.htm'
                        },
                        {
                            name: 'Netograf',
                            url: 'https://www.netograf.ro/'
                        },
                        {
                            name: 'Statistici pentru combaterea pandemiei',
                            url: 'https://www.vodafone.ro/libs/documents/digital_asset/v674310.pdf'
                        },
                    ]
                },
                {
                    name: 'Utile',
                    active: false,
                    children: [
                        {
                            name: 'Hartă acoperire reţea',
                            url: 'https://www.vodafone.ro/personal/servicii-si-tarife/alege-vodafone/harta-de-acoperire/index.htm'
                        },
                        {
                            name: 'Portare în rețea',
                            url: 'https://www.vodafone.ro/personal/servicii-si-tarife/alege-vodafone/portabilitate/index.htm#tab-1'
                        },
                        {
                            name: 'Procedură reclamaţii',
                            url: 'https://www.vodafone.ro/consumption/groups/public/documents/digital_asset/vod004382.pdf'
                        },
                        {
                            name: 'My Vodafone',
                            url: 'https://www.vodafone.ro/personal/campanii/aplicatia-myvodafone/index.htm'
                        },
                        {
                            name: 'My Vodafone Fix & TV',
                            url: 'https://www.vodafone.ro/consumption/groups/public/documents/digital_asset/v665536.pdf'
                        },
                        {
                            name: 'Vodafone TV',
                            url: 'https://www.vodafone.ro/personal/servicii-si-tarife/servicii-si-aplicatii/vodafone-tv/index.htm'
                        },
                        {
                            name: 'Vodafone Shake',
                            url: 'https://www.vodafone.ro/personal/servicii-si-tarife/servicii-si-aplicatii/shake/index.htm'
                        },
                        {
                            name: 'Toată lumea se joacă',
                            url: 'https://www.vodafone.ro/personal/servicii-si-tarife/cartela-vodafone/toata-lumea-castiga/index.htm'
                        },
                        {
                            name: 'Transfer de Conţinut și Diagnoză',
                            url: 'https://www.vodafone.ro/personal/magazin-online/utile/vodafone-transfer-continut/'
                        },
                        {
                            name: 'Aplicații partenere',
                            url: 'https://www.vodafone.ro/personal/servicii-si-tarife/servicii-si-aplicatii/aplicatii-si-jocuri/index.htm#tab-1'
                        },
                        {
                            name: 'Asigurare mobilă',
                            url: 'https://www.vodafone.ro/personal/magazin-online/utile/asigurare-mobila/index.htm'
                        },
                        {
                            name: 'RO Alert',
                            url: 'https://www.vodafone.ro/personal/magazin-online/utile/ro-alert/'
                        },
                        {
                            name: 'Intrebări frecvente',
                            url: 'https://www.vodafone.ro/personal/asistenta/index.htm'
                        },
                    ]
                }
            ]
        }
    },
    methods: {
        toggle(item) {
            item.active = !item.active
        },

        startTransition(el) {
            el.style.height = el.scrollHeight + 'px'
        },

        endTransition(el) {
            el.style.height = ''
        },
        getWindowWidth(event) {
            this.windowWidth = document.documentElement.clientWidth;
        }
    },
    mounted() {
        this.$nextTick(function() {
            const   date = new Date(),
                    year = date.getFullYear();
    
            this.copyYear = year;
            window.addEventListener('resize', this.getWindowWidth);
            this.getWindowWidth()
        })


    }

}
</script>

<style lang="scss" scoped>
    @import "~bootstrap/scss/functions";
    @import "~bootstrap/scss/variables";
    @import "~bootstrap/scss/mixins";
    @import "~bootstrap/scss/utilities";
    @import "~bootstrap/scss/grid";
    @import "~bootstrap/scss/reboot";

    .footer {
        font-family: "Vodafone Rg", Arial, Helvetica, sans-serif;
        font-weight: 500;
        font-size: 1.75rem;
        text-transform: none;
        color: rgb(255, 255, 255);
        background-color: rgb(51, 51, 51) !important;
        padding: 50px 0px;
        
        &--title {
            font-family: "Vodafone Lt", Arial, Helvetica, sans-serif;
            font-weight: 300;
            font-size: 1.5rem;
            text-transform: none;
            margin-bottom: 15px;
            position: relative;
            @include media-breakpoint-down(md) {
                margin: 12px 0
            }
            a {
                font-family: "Vodafone Rg", Arial, Helvetica, sans-serif;
                font-weight: 500;
                font-size: 1rem;
                color: rgb(255, 255, 255);
            }
        }
        &--annotation {
            font-family: "Vodafone Rg", Arial, Helvetica, sans-serif;
            font-weight: 500;
            font-size: 1rem;
            color: rgb(255, 255, 255);
            text-align: right;
            display: flex;
            -webkit-box-align: center;
            align-items: center;
            -webkit-box-pack: end;
            justify-content: flex-end;
            height: 100%;
            @include media-breakpoint-down(md) {
                justify-content: center;
            }
            a {
                font-family: "Vodafone Rg", Arial, Helvetica, sans-serif;
                font-weight: 500;
                font-size: 1rem;
                color: rgb(255, 255, 255);
            }
        }

        &--links {
            font-family: "Vodafone Rg", Arial, Helvetica, sans-serif;
            font-weight: 500;
            font-size: 1rem;
            color: rgb(255, 255, 255);
            text-decoration: none;
        }

        ul {
            list-style-type: none;
            margin: 0px;
            padding: 25px 0px;
            @include media-breakpoint-down(md) {
                padding: 0 0 25px;
            }
        }

        a {
            &:hover,
            &:active,
            &:visited,
            &:focus,
            &:link {
                text-decoration: none;
                color: rgb(255, 255, 255);
            }
        }
        
        .accordion-item-enter-active, .accordion-item-leave-active {
            will-change: height;
            transition: height 0.5s ease;
        }
        .accordion-item-enter, .accordion-item-leave-to {
           height: 0 !important;
        }

        .accordion-box {
            width: 24px;
            height: 24px;
            position: absolute;
            display: flex;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            svg {
                width: 24px;
                height: 24px;
            }
        }

        .accordion-item-details {
            overflow: hidden;
        }

        .accordion-item-trigger {
            &:before {
                top: -1px;
                left: 0;
                right: 0;
                height: 1px;
                content: "";
                opacity: 1;
                position: absolute;
                transition: opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
                background-color: rgb(255, 255, 255);
            }
            &.is-active {
                &:before {
                    background-color: #333333 !important;
                }
                svg {
                    transform: rotate(180deg);
                    transition: all .3s ease;
                }
            }
        }
    }

</style>